import React, {FC, useState, useEffect} from "react";
import {
  Container
} from './styles'
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { Table, TableSkeleton, TopProgress, Typography } from "../../../components";
import { billingService, configurationService, openStackService } from "../../../api";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
// import { StatusText } from "overview/styles";
import { HeadLine1 } from "../../../components/typography/styled";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/display-price";
import Skeleton from 'react-loading-skeleton'
import { useTheme } from "styled-components";
import { handleStatusName } from "../../../utils/handle-status-name";
import { icons } from "../../../icons";
import { useNavigate } from "react-router-dom";

const Configurations:FC = () => {
  const theme:any = useTheme()
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam)
  const [paginationData, setPaginationData] = useState<any>()
  const [invoices, setInvoices] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [t] = useTranslation()
  const navigate = useNavigate()
  const getInvoices = () => {
    setLoading(true)
    configurationService.getConfiguratonsList({
      page:page || 1,
      page_size:pageSize || 20,
      // ordering:ordering || '-issue_date',
    })
    .then((res) => {
      setInvoices(res.data.objects?.map((obj:any) => {
        return{
          ...obj,
          navigate:obj.id.toString(),
          pricing_rules_count:obj.pricing_rules?.length || 0,
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
      setLoading(false)
    })
    .catch((e) => {
      console.log('error', e);
    })
  }
  useEffect(() => {
    getInvoices()
    const interval = setInterval(() => {
      getInvoices()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,])
  const ColumnsInvoices = [
    {
      title:t("NAME"),
      key:'name'
    },
    {
      title:t("SERVICES_COUNT"),
      key:'services_count',
    },
    {
      title:t("PRICING_RULES_COUNT"),
      key:'pricing_rules_count',
    },
    {
      title:t("CURRENCY"),
      key:'currency',
    },
    {
      title:'',
      key:'props'
    }
  ]
  const contextMenu = [
    {
      title:t("CREATE_PRICING_RULE"),
      id:'3',
      icon:icons.PlusDefault,
      onClick: (item:any) => {
        navigate(`${item.id}/edit`)
      },
      divider:false
    },
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (item:any) => {
        navigate(`${item.id}/edit`)
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'3',
      icon:icons.DeleteIcon,
      onClick: (item:any) => {
        navigate(`${item.id}/edit`)
      },
      divider:false
    }
  ]
  if(pageLoading) return (
    <Container>
      <TopProgress loading={pageLoading}/>
      <Skeleton
        baseColor={theme.palette[300]}
        highlightColor={theme.palette[20]}
        width={125} style={{marginBottom:"5px"}} height={30}
      />
      <TableSkeleton
        rows={10}
        columns={5}
        // columnsData={Columns}
      />
    </Container>
  )
  return (
    <Container>

      <HeadLine1 style={{marginBottom:'10px'}}>
        {t("CONFIGURATIONS")}
      </HeadLine1>
      {invoices?.length > 0 ?
        <Table
          columns={ColumnsInvoices}
          rows={invoices}
          // hideOther
          hideCheckbox
          settings={contextMenu}
          paginationData={paginationData}
        />
      :
        <Typography variant="body">
          {t("NO_CONFIGURATIONS")}
        </Typography>
      }
    </Container>
  )
}

export default Configurations

